import { render } from "./PWAUpdateModal.vue?vue&type=template&id=72cc8144"
import script from "./PWAUpdateModal.vue?vue&type=script&lang=js"
export * from "./PWAUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__